import { Checkbox, CheckboxGroup } from '@/lib/base/forms/checkbox';

export interface VendorImportObjectType {
  name: string;
  label: string;
  description?: string;
}

export interface ObjectTypeConfigureStepProps {
  objectTypes: readonly VendorImportObjectType[];
  selected: string[];
  onChange: (names: string[]) => void;
  description?: string;
}

export function ObjectTypeConfigureStep({
  objectTypes,
  selected,
  onChange,
  description,
}: ObjectTypeConfigureStepProps) {
  return (
    <div className='flex flex-col gap-4'>
      {description && (
        <p className='text-sm text-[var(--color-text-secondary)]'>
          {description}
        </p>
      )}
      {/*
        The group owns the selection: react-aria routes a Checkbox nested in a
        CheckboxGroup through useCheckboxGroupItem, which reads its checked
        state from the group's value and ignores any isSelected passed to the
        child. Per-child isSelected/onChange therefore desyncs what is rendered
        from what the parent holds — keep value/onChange on the group alone.
      */}
      <CheckboxGroup
        aria-label='Record types to import'
        value={selected}
        onChange={onChange}
      >
        {objectTypes.map(type => (
          <Checkbox
            key={type.name}
            value={type.name}
            label={type.label}
            description={type.description}
          />
        ))}
      </CheckboxGroup>
    </div>
  );
}
